import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`Segmented/findAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`Segmented/findById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`Segmented/deleteById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  templateImport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`Segmented/templateImport`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveSegmented({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`Segmented/saveSegmented`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  templateUpload({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/Segmented/templateUpload',
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },






}
